import { globalConfig } from '../config/config';

class Urls {
  static getCreateNetworkUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/networks`;
    }
    return '';
  }

  static getInappNotificationsUrl(token: string): string {
    let url = '';
    if (globalConfig.config && globalConfig.config.InAppNotificationUrl) {
      url = globalConfig.config.InAppNotificationUrl;
      url = `${url}?token=${token}`;
      return url;
    }
    return url;
  }

  static getSignInUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.authPublicUrl;
      return `${url}/login`;
    }
    return '';
  }

  static getAuthUrl():string {
    if (globalConfig.config) {
      const url = globalConfig.config.authPublicUrl;
      return url;
    }
    return '';
  }

  static getAllNodes(id: string | number): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/networks/${id}/nodes`;
    }
    return '';
  }

  static addNodeUrl(id: string | number): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/networks/${id}/nodes`;
    }
    return '';
  }

  static getBackendUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return url;
    }
    return '';
  }

  static getAccessTokenUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.authPublicUrl;
      return `${url}/getNewToken`;
    }
    return '';
  }

  static getDashboardUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/dashboard`;
    }
    return '';
  }

  static getEndpointBuyUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/endpoint/buy`;
    }
    return '';
  }

  static getWorkspaceList(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appBackendApiUrl;
      return `${url}/workspace/list`;
    }
    return '';
  }

  static getWorkspaceUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/workspace`;
    }
    return '';
  }

  static getMyAccountUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/Account`;
    }
    return '';
  }

  static getCredId(id:string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appBackendApiUrl;
      return `${url}/cloud/authorized?cloudId=${id}`;
    }
    return '';
  }

  static getToWorkspace(str: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}${str}`;
    }
    return '';
  }

  static getCloudList(): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.appBackendApiUrl;
      return `${BASE_URL}/cloud/list`;
    }
    return '';
  }

  static getCloudRegion(cloudId: number | string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appBackendApiUrl;
      return `${url}/cloud/regions/${cloudId}`;
    }
    return '';
  }

  static getUserInfo(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appBackendApiUrl;
      return `${url}/dashboard/user-info`;
    }
    return '';
  }

  static deleteNetworkById(networkId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.protocolBackendApiUrl;
      return `${BASE_URL}/networks/${networkId}/delete`;
    }
    return '';
  }

  static getAllNetworkUrl(): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.platformFrontendUrl;
      return `${BASE_URL}/manage/nodes/full`;
    }
    return '';
  }

  static getNodeDetails(netId: string, nodeId: string): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.protocolBackendApiUrl;
      return `${BASE_URL}/networks/${netId}/nodes/${nodeId}`;
    }
    return '';
  }

  static getNetworkDetail(id: string | number): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/networks/${id}`;
    }
    return '';
  }

  static getNetworkListUrl(val: string, type: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      if (val === 'all') {
        return `${url}/networks/defaults?nodeType=${type}`;
      }

      return `${url}/networks/defaults?network=${val}&nodeType=${type}`;
    }
    return '';
  }

  static deleteNodeUrl(networkId: string, nodeId: string): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.protocolBackendApiUrl;
      return `${BASE_URL}/networks/${networkId}/nodes/${nodeId}/delete`;
    }
    return '';
  }

  static getContactDetails(): { email: string, helpdeskURL: string } {
    if (globalConfig.config) {
      const { email, helpdeskURL } = globalConfig.config.contacts;
      return { email, helpdeskURL };
    }
    return { email: '', helpdeskURL: '' };
  }

  static getCloudId(): string {
    if (globalConfig.config) {
      const { cloudId } = globalConfig.config;
      return cloudId;
    }
    return '';
  }

  static getDeploymentId(): string {
    if (globalConfig.config) {
      const { deploymentId } = globalConfig.config;
      return deploymentId;
    }
    return '';
  }

  static getAppTitle(): string {
    if (globalConfig.config) {
      const { appTitle } = globalConfig.config;
      return appTitle;
    }
    return '';
  }

  static getNodeInfoUrl(networkId: string, nodeId: string): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.protocolBackendApiUrl;
      return `${BASE_URL}/networks/${networkId}/nodes/${nodeId}/status`;
    }
    return '';
  }

  static getMarketplaceUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/marketplace`;
    }
    return '';
  }

  static getStakingMarketplaceUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/marketplace/staking-nodes`;
    }
    return '';
  }

  static getStakingNetworksUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.platformFrontendUrl;
      return `${url}/manage/nodes/validator`;
    }
    return '';
  }

  static getEndpointsUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/endpoints`;
    }
    return '';
  }

  static getItemCode(code: string): string {
    if (globalConfig.config) {
      const { itemCode } = globalConfig.config;
      return itemCode[code];
    }
    return '';
  }

  static getPaymentPlans(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/payments?usedFor=dedicatedNodes`;
    }
    return '';
  }

  static getPlansForSharedNodes(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/payments?usedFor=sharedNodes`;
    }
    return '';
  }

  static getSubscription(value: string): string {
    if (globalConfig.config) {
      const BASE_URL = globalConfig.config.protocolBackendApiUrl;
      return `${BASE_URL}/payments?usedFor=${value}`;
    }
    return '';
  }

  static getAvailableCount(params?: string[]): string {
    if (globalConfig.config) {
      const arrStr = encodeURIComponent(JSON.stringify(params));
      const id = globalConfig.config.protocolId;
      return `${globalConfig.config.appBackendApiUrl}/configuration/node?id=${id}&filter=${arrStr}`;
    }
    return '';
  }

  static getInstanceTypes(id:string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/cloud/instance-types/${id}`;
    }
    return '';
  }

  static getEndpointDetailsUrl(endpointId: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/${endpointId}`;
    }
    return '';
  }

  static getEndpointDeleteUrl(endpointId: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/${endpointId}/delete`;
    }
    return '';
  }

  static getUpdateEndpointNameOrSecurityUrl(type: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/update?updateFor=${type}`;
    }
    return '';
  }

  static getCreateEndpointUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints`;
    }
    return '';
  }

  static getEnvironment(): string {
    if (globalConfig.config) {
      return globalConfig.config.environment;
    }
    return '';
  }

  static getEndpointHttpUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.endpointUrl;
      return url.http;
    }
    return '';
  }

  static getEndpointWssUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.endpointUrl;
      return url.wss;
    }
    return '';
  }

  static isSharedApiEnabled(): boolean {
    if (globalConfig.config) {
      return globalConfig.config.sharedApiEnabled;
    }
    return false;
  }

  static getZdfsPurchaseUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zdfsUrl;
      return `${url}/purchase-subscription`;
    }
    return '';
  }

  static getZdfsManageUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zdfsUrl;
      return url;
    }
    return '';
  }

  static getZeeveManagedValue(): string {
    if (globalConfig.config) {
      const value = globalConfig.config.zeeveManagedCloud;
      return value;
    }
    return '';
  }

  static getSubsComQuotaUrl(subscriptionId: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/subscription/${subscriptionId}`;
    }
    return '';
  }

  static getEndpointMatricsUrl(endpointId: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/basics/${endpointId}`;
    }
    return '';
  }

  static getEndpointMethodCallUrl(endpointId: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/method-breakdown/${endpointId}`;
    }
    return '';
  }

  static getEndpointRecenetReqUrl(endpointId: string): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolBackendApiUrl;
      return `${url}/endpoints/recent-request/${endpointId}`;
    }
    return '';
  }

  static getZdexerURL(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zdexerPortalUrl;
      return url;
    }
    return '';
  }

  static getDocURL(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.docUrl;
      return url;
    }
    return '';
  }

  static isByocEnabled(): boolean {
    if (globalConfig.config) {
      return globalConfig.config.enableByoc;
    }
    return false;
  }

  static getVideosUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = config.videosUrl;
    }
    return url;
  }

  static getDocsUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = config.docUrl;
    }
    return url;
  }

  static getSubgraphUrl(service: 'manage-service' | 'buy-service'): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      // getting url based on the section name
      url = service === 'manage-service'
        ? `${config.subgraphUrl}/dashboard`
        : `${config.appFrontendUrl}/indexing-protocol/buy`;
    }

    return url;
  }

  static getAppchainURL(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appChainURL;
      return `${url}`;
    }
    return '';
  }

  static getSidebarModuleUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = config.module.sidebar;
    }
    return url;
  }

  static getOrganizationListUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appBackendApiUrl;
      return `${url}/organization/list`;
    }
    return '';
  }

  static getRegionListUrl(protocolId: string, pricingRequired: boolean): string {
    let url = '';

    const { config } = globalConfig;

    const BASE_URL = config?.appBackendApiUrl;

    url = `${BASE_URL}/v3/protocols/${protocolId}?pricingRequired=${pricingRequired}`;
    return url;
  }
}
export default Urls;
